module.exports = __webpack_public_path__ + "static/media/react.cd7bb6be.png";